import { ArrowLeft16Regular } from '@fluentui/react-icons';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { HelpArticleView } from '@web/modules/help/components/help-article-view';
import { HelpSearchInput } from '@web/modules/help/components/help-search-input';
import { HelpSidebar } from '@web/modules/help/components/help-sidebar';
import { ScrollArea } from '@web/shared/ui/scroll-area';

export const Route = createFileRoute('/help/$')({
  component: HelpArticleRoute,
});

function HelpArticleRoute() {
  const { t } = useTranslation();
  const params = Route.useParams() as Record<string, string | undefined>;
  const slug = params['_splat'] ?? '';

  return (
    <div className="flex h-full min-h-0 flex-1 overflow-hidden">
      {/* Topics Sidebar in ScrollArea */}
      <aside className="hidden md:flex w-72 shrink-0 flex-col border-r border-border bg-surface/30 h-full overflow-hidden">
        <div className="p-4 border-b border-border space-y-3 shrink-0">
          <Link
            to="/help"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-brand hover:underline"
          >
            <ArrowLeft16Regular className="size-3.5" />
            <span>{t('help.backToCenter', 'Voltar ao início da Central')}</span>
          </Link>
          <HelpSearchInput />
        </div>

        <ScrollArea className="flex-1 min-h-0">
          <div className="p-3">
            <HelpSidebar />
          </div>
        </ScrollArea>
      </aside>

      {/* Article Content Area in ScrollArea */}
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden bg-background">
        <div className="md:hidden border-b border-border p-3 flex items-center justify-between shrink-0">
          <Link
            to="/help"
            className="inline-flex items-center gap-1.5 text-xs font-medium text-brand hover:underline"
          >
            <ArrowLeft16Regular className="size-3.5" />
            <span>{t('help.backToCenter', 'Voltar ao início da Central')}</span>
          </Link>
          <div className="w-48">
            <HelpSearchInput />
          </div>
        </div>

        <ScrollArea className="flex-1 min-h-0">
          <div className="mx-auto max-w-3xl px-6 py-8 sm:px-10">
            <HelpArticleView slug={slug} />
          </div>
        </ScrollArea>
      </main>
    </div>
  );
}
